<template>
  <div class="app-footer" dir="rtl">
    <v-footer :app="true" absolute class="footer-background">
      <v-container fluid style="width: 80%">
        <v-row class="pb-13" dir="rtl">
          <v-col cols="12" sm="12" md="12" lg="3" class="cols">
            <v-card class="footer-card cardo mt-4 text-center" elevation="0">
              <!-- Logo at the top -->
              <img
                src="@/assets/logo.png"
                class="logos"
                @click="$router.push({ name: 'home' })"
                alt="mizabook"
              />

              <!-- SVG and text in a row -->
              <v-row
                dir="ltr"
                class="text-center"
                style="justify-content: center; margin-right: 30px"
              >
                <v-col cols="auto" class="pl-6 pr-2 mr-0 text-center">
                  <svg
                    width="33px"
                    height="33px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#000000"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M10.0376 5.31617L10.6866 6.4791C11.2723 7.52858 11.0372 8.90532 10.1147 9.8278C10.1147 9.8278 10.1147 9.8278 10.1147 9.8278C10.1146 9.82792 8.99588 10.9468 11.0245 12.9755C13.0525 15.0035 14.1714 13.8861 14.1722 13.8853C14.1722 13.8853 14.1722 13.8853 14.1722 13.8853C15.0947 12.9628 16.4714 12.7277 17.5209 13.3134L18.6838 13.9624C20.2686 14.8468 20.4557 17.0692 19.0628 18.4622C18.2258 19.2992 17.2004 19.9505 16.0669 19.9934C14.1588 20.0658 10.9183 19.5829 7.6677 16.3323C4.41713 13.0817 3.93421 9.84122 4.00655 7.93309C4.04952 6.7996 4.7008 5.77423 5.53781 4.93723C6.93076 3.54428 9.15317 3.73144 10.0376 5.31617Z"
                        stroke="#000000"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      ></path>
                    </g>
                  </svg>
                </v-col>
                <v-col cols="auto" class="px-0 ml-0">
                  <!-- Text next to the SVG -->
                  <div
                    dir="ltr"
                    class="text-center"
                    style="font-size: large; font-weight: bold"
                  >
                    +212 706322941
                  </div>
                </v-col>
              </v-row>
              <v-row
                dir="ltr"
                class="text-center"
                style="
                  justify-content: center;
                  margin-top: -28px;
                  margin-right: 20px;
                "
              >
                <v-col cols="auto" class="pl-6 pr-2 mr-0">
                  <svg
                    width="30px"
                    height="30px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 8L8.44992 11.6333C9.73295 12.4886 10.3745 12.9163 11.0678 13.0825C11.6806 13.2293 12.3194 13.2293 12.9322 13.0825C13.6255 12.9163 14.2671 12.4886 15.5501 11.6333L21 8M6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19Z"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </v-col>
                <v-col cols="auto" class="px-0 ml-0">
                  <!-- Text next to the SVG -->
                  <div style="font-size: large; font-weight: bold">
                    support@mizabook.com
                  </div>
                </v-col>
              </v-row>
            </v-card>
            <div
              dir="ltr"
              class="social d-flex mt-2"
              style="gap: 20px; justify-content: center"
            >
              <span
                class="facebook d-flex align-center justify-center"
                style="width: 35px; height: 35px"
              >
                <a
                  href="https://web.facebook.com/profile.php?id=61566811787758"
                  target="_blank"
                  class="social-icon"
                >
                  <svg
                    width="35px"
                    fill="#000000"
                    viewBox="0 0 32 32"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <title>facebook</title>
                      <path
                        d="M30.996 16.091c-0.001-8.281-6.714-14.994-14.996-14.994s-14.996 6.714-14.996 14.996c0 7.455 5.44 13.639 12.566 14.8l0.086 0.012v-10.478h-3.808v-4.336h3.808v-3.302c-0.019-0.167-0.029-0.361-0.029-0.557 0-2.923 2.37-5.293 5.293-5.293 0.141 0 0.281 0.006 0.42 0.016l-0.018-0.001c1.199 0.017 2.359 0.123 3.491 0.312l-0.134-0.019v3.69h-1.892c-0.086-0.012-0.185-0.019-0.285-0.019-1.197 0-2.168 0.97-2.168 2.168 0 0.068 0.003 0.135 0.009 0.202l-0.001-0.009v2.812h4.159l-0.665 4.336h-3.494v10.478c7.213-1.174 12.653-7.359 12.654-14.814v-0z"
                      ></path>
                    </g>
                  </svg>
                </a>
              </span>
              <span
                class="facebook d-flex align-center justify-center"
                style="width: 35px; height: 35px"
              >
                <a
                  href="https://www.instagram.com/mizabook/"
                  target="_blank"
                  class="social-icon"
                >
                  <svg
                    width="35px"
                    fill="#000000"
                    viewBox="0 0 32 32"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M20.445 5h-8.891A6.559 6.559 0 0 0 5 11.554v8.891A6.559 6.559 0 0 0 11.554 27h8.891a6.56 6.56 0 0 0 6.554-6.555v-8.891A6.557 6.557 0 0 0 20.445 5zm4.342 15.445a4.343 4.343 0 0 1-4.342 4.342h-8.891a4.341 4.341 0 0 1-4.341-4.342v-8.891a4.34 4.34 0 0 1 4.341-4.341h8.891a4.342 4.342 0 0 1 4.341 4.341l.001 8.891z"
                      ></path>
                      <path
                        d="M16 10.312c-3.138 0-5.688 2.551-5.688 5.688s2.551 5.688 5.688 5.688 5.688-2.551 5.688-5.688-2.55-5.688-5.688-5.688zm0 9.163a3.475 3.475 0 1 1-.001-6.95 3.475 3.475 0 0 1 .001 6.95zM21.7 8.991a1.363 1.363 0 1 1-1.364 1.364c0-.752.51-1.364 1.364-1.364z"
                      ></path>
                    </g>
                  </svg>
                </a>
              </span>
              <span
                class="facebook d-flex align-center justify-center"
                style="width: 35px; height: 35px"
              >
                <a
                  href="https://www.tiktok.com/@mizabook"
                  target="_blank"
                  class="social-icon"
                >
                  <svg
                    width="35px"
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    fill="#000000"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <title>tiktok_fill</title>
                      <g
                        id="页面-1"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="Brand"
                          transform="translate(-720.000000, -48.000000)"
                        >
                          <g
                            id="tiktok_fill"
                            transform="translate(720.000000, 48.000000)"
                          >
                            <path
                              d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
                              id="MingCute"
                              fill-rule="nonzero"
                            ></path>
                            <path
                              d="M14,2 C15.1046,2 16,2.89543 16,4 C16,5.44733 17.03,6.6618 18.3984,6.93991 C19.4808,7.15992 20.1799,8.21575 19.9599,9.29819 C19.7399,10.3806 18.6841,11.0798 17.6016,10.8598 C17.0406,10.7457 16.5037,10.5646 16,10.3252 L16,16 C16,19.3137 13.3137,22 10,22 C6.68629,22 4,19.3137 4,16 C4,13.2015 5.91407,10.8551 8.50148,10.1891 C9.57119,9.91382 10.6616,10.5578 10.9369,11.6275 C11.2122,12.6972 10.5682,13.7876 9.49852,14.0629 C8.63547,14.285 8,15.0708 8,16 C8,17.1046 8.89543,18 10,18 C11.1046,18 12,17.1046 12,16 L12,4 C12,2.89543 12.8954,2 14,2 Z"
                              id="路径"
                              fill="#000000"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </span>
              <span
                class="facebook d-flex align-center justify-center"
                style="width: 35px; height: 35px"
              >
                <a
                  href="https://wa.link/aktzzb"
                  target="_blank"
                  class="social-icon"
                >
                  <svg
                    width="35px"
                    fill="#000000"
                    viewBox="-2 -2 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMinYMin"
                    class="jam jam-whatsapp"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M9.516.012C4.206.262.017 4.652.033 9.929a9.798 9.798 0 0 0 1.085 4.465L.06 19.495a.387.387 0 0 0 .47.453l5.034-1.184a9.981 9.981 0 0 0 4.284 1.032c5.427.083 9.951-4.195 10.12-9.58C20.15 4.441 15.351-.265 9.516.011zm6.007 15.367a7.784 7.784 0 0 1-5.52 2.27 7.77 7.77 0 0 1-3.474-.808l-.701-.347-3.087.726.65-3.131-.346-.672A7.62 7.62 0 0 1 2.197 9.9c0-2.07.812-4.017 2.286-5.48a7.85 7.85 0 0 1 5.52-2.271c2.086 0 4.046.806 5.52 2.27a7.672 7.672 0 0 1 2.287 5.48c0 2.052-.825 4.03-2.287 5.481z"
                      ></path>
                      <path
                        d="M14.842 12.045l-1.931-.55a.723.723 0 0 0-.713.186l-.472.478a.707.707 0 0 1-.765.16c-.913-.367-2.835-2.063-3.326-2.912a.694.694 0 0 1 .056-.774l.412-.53a.71.71 0 0 0 .089-.726L7.38 5.553a.723.723 0 0 0-1.125-.256c-.539.453-1.179 1.14-1.256 1.903-.137 1.343.443 3.036 2.637 5.07 2.535 2.349 4.566 2.66 5.887 2.341.75-.18 1.35-.903 1.727-1.494a.713.713 0 0 0-.408-1.072z"
                      ></path>
                    </g>
                  </svg>
                </a>
              </span>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="3" class="cols">
            <v-card class="footer-card cardo" elevation="0">
              <v-card-title class="footer-title pb-8">روابط مهمة</v-card-title>
              <v-card-text
                class="footer-text"
                style="cursor: pointer"
                @click="
                  $router.push({
                    name: 'question',
                  })
                "
                >أسئلة شائعة</v-card-text
              >
              <v-card-text
                class="footer-text"
                style="cursor: pointer"
                @click="
                  $router.push({
                    name: 'contact_us',
                  })
                "
                >إتصل بنا</v-card-text
              >
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="3" class="cols">
            <v-card class="footer-card cardo" elevation="0">
              <v-card-title class="footer-title pb-6">معلومات</v-card-title>
              <v-card-text
                class="footer-text"
                style="cursor: pointer"
                @click="
                  $router.push({
                    name: 'about_us',
                  })
                "
                >من نحن</v-card-text
              >
              <v-card-text
                class="footer-text"
                style="cursor: pointer"
                @click="
                  $router.push({
                    name: 'confidentiality',
                  })
                "
                >سياسة الخصوصية</v-card-text
              >
              <v-card-text
                class="footer-text"
                style="cursor: pointer"
                @click="
                  $router.push({
                    name: 'shipping_delivery',
                  })
                "
                >الشحن</v-card-text
              >
              <v-card-text
                class="footer-text"
                style="cursor: pointer"
                @click="
                  $router.push({
                    name: 'return_refund',
                  })
                "
                >سياسة الاستبدال والاسترجاع</v-card-text
              >
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="3" class="cols dirst">
            <v-card class="footer-card" elevation="0">
              <v-card-title class="footer-title">تصنيفات</v-card-title>

              <v-row dir="rtl">
                <!-- First column for the first half of categories -->

                <v-col cols="6">
                  <v-card-text
                    class="footer-text"
                    v-for="cat in categories.slice(
                      0,
                      Math.ceil(categories.length / 2)
                    )"
                    :key="cat.title"
                  >
                    <router-link
                      :to="{
                        name: 'products_category',
                        query: { category: cat.route, title: cat.title },
                      }"
                      style="color: #6c757d; text-decoration: none"
                      >{{ cat.title }}</router-link
                    >
                  </v-card-text>
                </v-col>

                <!-- Second column for the second half of categories -->
                <v-col cols="6">
                  <v-card-text
                    class="footer-text"
                    v-for="cat in categories.slice(
                      Math.ceil(categories.length / 2),
                      categories.length
                    )"
                    :key="cat.title"
                  >
                    <router-link
                      :to="{
                        name: 'products_category',
                        query: { category: cat.route, title: cat.title },
                      }"
                      style="color: #6c757d; text-decoration: none"
                      >{{ cat.title }}</router-link
                    >
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="bg-grey-lighten-2 pt-2 pb-2 mt-0 footer-row">
          <v-col cols="12" class="text-center">
            <p class="footer-txt" dir="ltr">
              &copy; {{ new Date().getFullYear() }} Miza Book. All Rights
              Reserved. Powered By Ryozo
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </div>
</template>
<script>
import { useProductsModule } from "@/stores/products";
import { mapState } from "pinia";
export default {
  computed: {
    ...mapState(useProductsModule, ["categories"]),
  },
};
</script>
<style scoped>
@import url("https://fonts.google.com/noto/specimen/Noto+Kufi+Arabic?lang=ar_Arab");

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  transition: transform 0.3s;
}

.social-icon:hover {
  transform: scale(1.2);
  cursor: pointer;
}
/* Footer background and spacing */
.footer-background {
  background-color: #f8f9fa;

  border-top: 1px solid #e7e7e7;
}

/* Footer card styles */
.footer-card {
  padding-top: 10px;
  background-color: transparent;
  justify-content: center;
}

/* Remove padding between v-cols */
.zero {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
/* Footer title styling */
.footer-title {
  font-family: "Noto Kufi Arabic", sans-serif;
  font-size: 17px;
  font-weight: 900;
  direction: rtl;
  color: #343a40;
  text-align: center;
}

/* Footer text styling */
.footer-text {
  direction: rtl;
  font-size: 17px;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: -15px;
  text-align: center;
}
.dirst {
  padding-right: -100px;
}
.logos {
  cursor: pointer;
  width: 60%;
  justify-content: center;
}

/* Extra styling to enhance responsiveness */
@media (max-width: 600px) {
  .footer-title {
    font-size: 16px;
  }
  .footer-text {
    font-size: 13px;
  }
}
.cols {
  position: relative;
}
@media (min-width: 1280px) {
  .cols:not(:last-child)::after {
    content: " ";
    position: absolute;
    top: 25%;
    left: 10px; /* Position on the left side of the column */
    width: 3px; /* Width of the divider */
    background-color: #adadad; /* Color of the divider */
    height: 50%; /* Full height of the column */
  }
}
.footer-row {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: auto;
  padding-left: 16px;
  padding-right: 16px;
}

.footer-txt {
  margin-bottom: 0;
}

/* Adjustments for small screens */
@media (max-width: 600px) {
  .footer-row {
    padding-left: auto;
    padding-right: auto;
  }
}

@media (max-width: 1280px) {
  .logos {
    width: 20%;
  }
}
@media (max-width: 930px) {
  .logos {
    width: 40%;
  }
}
@media (max-width: 670px) {
  .logos {
    width: 50%;
  }
}
</style>
